const library = 'library' as const;

export const links = {
  getStorageLink: (section: string) => `/${library}/storage?section=${section}`
} as const;
